import { ThemeType } from './themeMapper';

export const getThemeType = (attributes?: string[]) => {
  if (attributes?.includes(ThemeType.DarkMode)) return ThemeType.DarkMode;
  return ThemeType.DefaultMode;
};
